import ConfirmationSuccess from 'fe-design-base/assets/illustrations/ConfirmationSuccess';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';

interface MemberAddedModalProps {
  candidateFirstName: string;
}

const MemberAddedModal = ({ candidateFirstName }: MemberAddedModalProps) => (
  <>
    <Box flex column justifyContentCenter alignItemsCenter>
      <ConfirmationSuccess />
    </Box>
    <Box mt={20} mb={24}>
      <Text
        variant="heading2"
        color="mono900"
        i18n="hiring.dashboard.v2.interview.to_review.follow_up.member_added_modal_title"
        i18nProps={{ candidateFirstName }}
      />
    </Box>
    <Box flex column gap={20}>
      <Text
        variant="heading3"
        color="mono900"
        i18n="hiring.dashboard.v2.interview.to_review.follow_up.member_added_modal_subtitle"
      />
      <Box flex gap={16} alignItemsCenter>
        <Box flex alignItemsCenter gap={16}>
          <Icon id="complete" iconName="Complete" color="mono400" />
          <Text
            variant="body"
            color="mono900"
            i18n="hiring.dashboard.v2.interview.to_review.follow_up.member_added_modal_background_check"
          />
        </Box>
      </Box>
    </Box>
  </>
);

export default MemberAddedModal;
